import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_TYPE } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

const FILTER_TABS = 'filter_tabs';

// https://dataportal.zillowgroup.net/event-registry/3374
export const VIEW_ALL_FILTER_CLICK_EVENT_TYPE_ID = '3374';
export const emitViewAllFilterClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: VIEW_ALL_FILTER_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'view_all_filter',
      trigger_object_nm: FILTER_TABS,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.FilterMessages,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3375
export const INQUIRIES_FILTER_CLICK_EVENT_TYPE_ID = '3375';
export const emitInquiriesFilterClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: INQUIRIES_FILTER_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'inquiries_filter',
      trigger_object_nm: FILTER_TABS,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.FilterMessages,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3376
export const TOURS_FILTER_CLICK_EVENT_TYPE_ID = '3376';
export const emitToursFilterClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: TOURS_FILTER_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'tours_filter',
      trigger_object_nm: FILTER_TABS,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.FilterMessages,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3377
export const APPLICANTS_FILTER_CLICK_EVENT_TYPE_ID = '3377';
export const emitApplicantsFilterClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: APPLICANTS_FILTER_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'applicants_filter',
      trigger_object_nm: FILTER_TABS,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.FilterMessages,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3378
export const TENANTS_FILTER_CLICK_EVENT_TYPE_ID = '3378';
export const emitTenantsFilterClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: TENANTS_FILTER_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'tenants_filter',
      trigger_object_nm: FILTER_TABS,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.FilterMessages,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });
